<template>
  <div>
    <div v-for="(item, key) in quickBars" :key="key" class="link-item brush-item">
      <div class="link-item-name" @click="goHelpCenter(item)">
        <div class="link-item-image">
          <img :src="item.image" alt="">
        </div>
        <div class="link-item-text">
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleHelpCenterLink } from '@/utils/tool'
import { info } from '@/api/user'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  mixins: [themeMixin],
  data() {
    return {
      quickBars: []
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'memberInfo', 'brand']),
    token() {
      return this.$store.getters.token
    },
    banner() {
      return this.brand.banners[0]
    },
    licenseId() {
      return this.banner?.link.match(/licence\/(\d+)/)?.[1] || null
    }
  },
  watch: {
    licenseId(newVal) {
      if (newVal && !this.isTheme('theme_gold')) {
        this.initLiveChat()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.quickBars = this.$store.state.brand.quickBars.filter((item) => {
          return item.type === 'web'
        })
      }, 1000)
    })
  },
  mounted() {
    if (this.licenseId !== null && !this.isTheme('theme_gold')) {
      this.initLiveChat()
    }
    if (this.isTheme('theme_gold')) {
      this.initLiveChatAI()
    }
  },
  methods: {
    initLiveChat() {
      // licenseId : KT: 16229799
      // licenseId : UB: 19394384
      window.__lc = window.__lc || {}
      window.__lc.license = this.licenseId

      ;(function(n, t, c) {
        function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: '2.0', on: function() { i(['on', c.call(arguments)]) }, once: function() { i(['once', c.call(arguments)]) }, off: function() { i(['off', c.call(arguments)]) }, get: function() { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(['get', c.call(arguments)]) }, call: function() { i(['call', c.call(arguments)]) }, init: function() {
          var n = t.createElement('script'); n.async = !0; n.type = 'text/javascript'; n.src = 'https://cdn.livechatinc.com/tracking.js'; t.head.appendChild(n)
        } }; !n.__lc.asyncInit && e.init(); n.LiveChatWidget = n.LiveChatWidget || e
      }(window, document, [].slice))

      function onVisibilityChanged(data) {
        switch (data.visibility) {
          case 'minimized':
            LiveChatWidget.call('hide')
            break
          case 'hidden':
            break
        }
      }

      // Wait for LiveChatWidget to be ready before setting up events and hiding
      LiveChatWidget.on('ready', () => {
        LiveChatWidget.on('visibility_changed', onVisibilityChanged)
        LiveChatWidget.call('hide')
      })
      console.log('[LiveChat] Loaded')
    },
    initLiveChatAI() {
      const kycStatusMap = {
        0: 'KYC_NONE',
        1: 'KYC_PASS',
        2: 'KYC_PROGRESS'
      }

      if (this.token) {
        info().then(response => {
          const livechatHash = response.data.data.livechat.hash
          const memberInfo = this.user.memberInfo
          // 設定 identity
          window.lc = window.lc || {}
          window.lc.debug = true // 開發用
          window.lc.identity = {
            distinctId: memberInfo.id,
            userHash: livechatHash,
            name: memberInfo.username || 'User',
            attributes: {
              email: memberInfo.email,
              kycStatus: kycStatusMap[memberInfo.is_pass_KYC],
              first_deposit_amount: memberInfo.first_deposit_amount,
              second_deposit_amount: memberInfo.second_deposit_amount,
              third_deposit_amount: memberInfo.third_deposit_amount
            }
          }
        }).catch(error => {
          console.error(error)
        })
      }
      // 避免重複載入
      if (document.getElementById('livechatAI-script')) return
      const script = document.createElement('script')
      script.src = 'https://app.livechatai.com/embed.js'
      script.setAttribute('data-id', 'cmgacwvr40003l104ey1r81s3')
      script.id = 'livechatAI-script'
      script.async = true
      script.defer = true

      document.body.appendChild(script)
      console.log('[LiveChatAI] Loaded')
    },
    goHelpCenter(item) {
      const isGuest = !this.token
      const user = this.user
      const userInfo = this.memberInfo
      const vipInfo = user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, item, user, userInfo, vipInfo, dateFormatter)
    }
  }

}
</script>

